import './default_module'
import 'd3'
import c3 from 'c3'

import 'stylesheets/ubold_theme/gitb_custom/_timeline.scss'
import 'stylesheets/ubold_theme/gitb_custom/_c3.scss'
import 'stylesheets/ubold_theme/custom.scss'

$( document ).ready(function() {
    "use strict";

    var productID = $('#product_id').val();
    var colors = ["#9dc468", "#f7b84b", "#4a81d4", "#6c757d", "#E5E6E1"];

    c3.generate({
        bindto: '#industry-visitors',
        data: {
            url: '/vendor_dashboards/visitor_stats?type=visitor&id='+productID,
            mimeType: 'json',
            type: 'pie'
        },
        color: {
            pattern: colors
        },
        pie: {
            label: {
                show: false
            }
        }
    });

    c3.generate({
        bindto: '#industry-reviewers',
        data: {
            url: '/vendor_dashboards/visitor_stats?type=reviewer&id='+productID,
            mimeType: 'json',
            type: 'bar'
        },
        color: {
            pattern: colors
        },
        axis: {
            x: {
                show: false
            },
            y: {
                label: {
                    text: 'Number of reviews',
                }
            }
        },
        padding: {
            bottom: 20
        }
    });
});
